<script module>
  export const meta = {
    title: 'Movement of the day (MOD)',
    teaser:
      'The Movement of the Day (MOD) features a distinct movement highlighted in all\nsessions for that day, chosen randomly. It serves as a conversational icebreaker\nto foster a sense of community among users by offering a shared experience.',
    sort: 4,
  }
</script>

<p>
  The Movement of the Day (MOD) is a feature where a different movement is
  highlighted and included in all sessions for that particular day. This
  movement is selected randomly and distinguished by a highlighted color,
  ensuring it stands out.
</p>
<p>
  The purpose of the MOD is to introduce a common element across all users'
  experiences. It acts as a conversation starter or an icebreaker, providing a
  shared topic for discussion. The idea is to strengthen the sense of community
  among users by having a singular movement that everyone, regardless of their
  preferences, will encounter in their daily session. This shared experience,
  whether it's a movement you look forward to or one you're less enthusiastic
  about, contributes to building connections within the community.
</p>
